import React from "react";
import { Error } from "Components/shared/oneui";

function FilterErrorState({ onRetry }) {
  return (
    <Error
      actions={[
        {
          icon: "retry",
          onClick: onRetry,
          text: "Try Again",
          variant: "RETRY",
        },
      ]}
      heading={{
        props: {
          className: "twside-text-gray-900",
          variant: "SH3",
          weight: "semi-bold",
        },
        text: "Unable to load Filters",
      }}
      imageProps={{
        height: "72px",
        type: "system-error",
        width: "72px",
      }}
    />
  );
}

export default FilterErrorState;
